var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMedal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.124 9.963l-2.512-1.436c-.951-.54-2.278-.54-3.222 0L9.878 9.97v-.526C9.878 7.87 10.75 7 12.348 7h3.307c1.596 0 2.47.869 2.47 2.444v.519z",
    fill: "#655AEC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.045 11.131l-.965-.546-2.001-1.142c-.61-.35-1.547-.35-2.158 0l-2.001 1.135-.965.56-.128.063c-1.242.827-1.327.98-1.327 2.305v3.165c0 1.324.085 1.478 1.355 2.326l3.066 1.744c.305.182.689.259 1.079.259.383 0 .774-.084 1.079-.26l3.094-1.764c1.249-.827 1.327-.974 1.327-2.305v-3.165c0-1.324-.085-1.478-1.355-2.326l-.1-.049z",
    fill: "#655AEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.547 15.579a.503.503 0 00-.113.329l.042.672c.029.414-.27.624-.66.477l-.631-.252a.637.637 0 00-.362 0l-.632.245c-.39.154-.688-.063-.66-.477l.043-.672a.503.503 0 00-.114-.33l-.44-.517c-.27-.316-.149-.666.255-.77l.66-.169a.571.571 0 00.284-.21l.37-.56c.226-.35.588-.35.823 0l.369.56a.561.561 0 00.284.21l.66.168c.404.105.525.455.255.77l-.433.526z",
    fill: "#FEAAFF"
  }))));
}

export default SvgMedal;